module.exports = __webpack_public_path__ + "static/media/item_2_11_comp.476a5228.png";